export enum DataProviderContextEnum {
    Common = 'Common',
    Checklist = 'Checklist'
}